export default {
  TYPE: {
    COLLEGE: 'COLLEGE',
    CORPORATE: 'CORPORATE',
  },
}
